module.exports = __webpack_public_path__ + "media/icons/down-arrow-eab98a23.png";